// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['pl_PL']  = { // eslint-disable-line import/no-commonjs
  name: 'pl_PL',
  day: {
    abbrev: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
    full: [
      'niedziela',
      'poniedziałek',
      'wtorek',
      'środa',
      'czwartek',
      'piątek',
      'sobota'
    ]
  },
  month: {
    abbrev: [
      'Sty',
      'Lut',
      'Mar',
      'Kwi',
      'Maj',
      'Czer',
      'Lip',
      'Sie',
      'Wrz',
      'Paz',
      'Lis',
      'Gru'
    ],
    full: [
      'styczeń',
      'luty',
      'marzec',
      'kwiecień',
      'maj',
      'czerwiec',
      'lipiec',
      'sierpień',
      'wrzesień',
      'październik',
      'listopad',
      'grudzień'
    ]
  },
  meridiem: ['', ''],
  date: '%d.%m.%Y',
  time24: '%T',
  dateTime: '%a, %-d %b %Y, %T',
  time12: '',
  full: '%a, %-d %b %Y, %T %Z'
}

